import axiosServer from '@/configs/axiosServer.js'
import axiosServerGolang from '@/configs/axiosServerGolang.js'

export default {
  async requestGroup ({ Authorization, data }) {
    try {
      return await axiosServer({
        method: 'POST',
        url: '/program/resource_group/request_group/',
        headers: {
          Authorization
        },
        data
      })
    } catch (error) {
      console.error(error, 'Failed to request group')
    }
  },
  async getSubjectReferences (accessToken) {
    try {
      const result = await axiosServer({
        method: 'GET',
        url: '/program/subject/list/',
        headers: {
          Authorization: accessToken
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getPrakerjaProgram ({ accessToken, programId, groupId }) {
    try {
      const query = {}
      if (groupId) query.group_id = groupId
      return await axiosServer({
        method: 'GET',
        url: `/program/get/${programId}`,
        headers: {
          Authorization: accessToken
        },
        params: query
      })
    } catch (error) {
      console.error(error, 'Failed to request group')
    }
  },
  async getBulkProgramStudyGroupSchedule ({ accessToken, programIdList, userId }) {
    try {
      return await axiosServerGolang({
        method: 'POST',
        url: '/program-core/get-bulk/user-program-study-group-schedule',
        headers: {
          Authorization: accessToken
        },
        data: {
          program_ids: programIdList,
          user_id: userId,
          redeem_status: true
        }
      })
    } catch (error) {
      console.error(error, 'Failed to get program study group schedule')
    }
  },
  async getClosestSchedule ({ accessToken, userId }) {
    try {
      return await axiosServerGolang({
        method: 'GET',
        url: `/program-activity/closest-schedules/${userId}`,
        headers: {
          Authorization: accessToken
        }
      })
    } catch (error) {
      console.error(error, 'Failed to get closest schedule')
    }
  },
  async getSubjectListPopular (accessToken, payload = {}) {
    try {
      const queries = new URLSearchParams(payload).toString()
      const result = await axiosServerGolang({
        method: 'GET',
        url: `/program-core/subject-list-popular?${queries}`,
        headers: {
          Authorization: accessToken
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async fetchUserAssessment ({ accessToken, ...payload }) {
    try {
      const { page = 1, perPage = 9 } = payload
      return await axiosServerGolang({
        method: 'GET',
        url: `/program-activity/talentics/assessment-user/${page}/${perPage}`,
        headers: {
          Authorization: accessToken
        }
      })
    } catch (error) {
      console.error(error, 'Failed to fetch user assessment')
    }
  },
  async fetchActivityProgramPrakerja ({ accessToken }) {
    try {
      return await axiosServerGolang({
        method: 'GET',
        url: '/program-activity/program-prakerja-detail',
        headers: {
          Authorization: accessToken
        }
      })
    } catch (error) {
      console.error(error, 'Failed to fetch prakerja program activity')
    }
  }
}
